import { useEffect, useRef } from "react";
import usePortal from "react-useportal";
import useSSR from "use-ssr";

const DRAWER_CONTAINER = "search-autosuggest-fe__portal-container";

export const useMainPortal = () => {
  const { isBrowser } = useSSR();

  const bodyRef = useRef<HTMLBodyElement | null>(null);

  const containerRef = useRef<HTMLDivElement | null>(null);

  if (isBrowser && (!bodyRef.current || !containerRef.current)) {
    bodyRef.current = document.querySelector("body");
    containerRef.current = document.createElement("div");
    containerRef.current.classList.add(DRAWER_CONTAINER);
    bodyRef.current?.appendChild(containerRef.current);
  }

  const options =
    containerRef.current !== null
      ? { bindTo: containerRef.current }
      : undefined;

  const { Portal } = usePortal(options);

  const headerRef = useRef<HTMLElement | null>(null);
  const mainRef = useRef<HTMLElement | null>(null);
  const footerRef = useRef<HTMLElement | null>(null);

  if (
    isBrowser &&
    (!headerRef.current || !mainRef.current || !footerRef.current)
  ) {
    headerRef.current = document.querySelector("header");
    mainRef.current = document.querySelector("main");
    footerRef.current = document.querySelector("footer");

    headerRef.current?.setAttribute("aria-hidden", "true");
    mainRef.current?.setAttribute("aria-hidden", "true");
    footerRef.current?.setAttribute("aria-hidden", "true");
  }

  // uncoment the code to make the feature working localy
  /*  
  const localRef = useRef<Element | null>(null);
  if (isBrowser && !localRef.current) {
    // eslint-disable-next-line prefer-destructuring
    localRef.current = document.querySelector("#search-bar-root");
    localRef.current?.setAttribute("aria-hidden", "true");
  }
  useEffect(() => () => localRef.current?.removeAttribute("aria-hidden"), []);
  */

  useEffect(
    () => () => {
      if (containerRef.current) {
        bodyRef.current?.removeChild(containerRef.current);
      }
      containerRef.current = null;
      bodyRef.current = null;

      headerRef.current?.removeAttribute("aria-hidden");
      mainRef.current?.removeAttribute("aria-hidden");
      footerRef.current?.removeAttribute("aria-hidden");
    },
    [],
  );

  return Portal;
};
